import { Assets } from "assets/Assets";
import { Service } from "../types";

export const servicesMock: Service[] = [
  {
    id: 1,
    elementId: "consultation",
    image: Assets.About.consultation,
    title: "КОНСУЛТАЦИЯ",
    content:
      "Насреща сме да изберем заедно най-подходящия климатик за вас. Ако се налага, ще ви посетим в удобно за вас време, за да уточним на място всичко, което е нужно.",
  },
  {
    id: 2,
    elementId: "prevention",

    image: Assets.About.prevention,
    title: "ПРОФИЛАКТИКА",
    content: "Ще проверим и почистим климатика ви.",
  },

  {
    id: 3,
    elementId: "install",

    image: Assets.About.install,
    title: "МОНТАЖ",
    content: "Нашите монтажни групи ще монтират чисто и прецизно избрания от вас климатик.",
  },
  {
    id: 4,
    elementId: "service",

    image: Assets.About.service,
    title: "СЕРВИЗ",
    content: "От смяна на датчик до смяна на тяло - нашия сервиз се справя с всичко.",
  },
];
